<template>
  <v-card class="chart">
    <v-card-title class="body-2 pb-0">
      {{ title }}
    </v-card-title>
    <v-card-text class="py-0">
      <v-data-table
        :headers="headers"
        :items="items"
        rows-per-page-text=""
        :rows-per-page-items="[5]"
        :pagination.sync="pagination"
        class="elevation-0 "
      >
        <template slot="headers" slot-scope="props">
          <tr style="height:40px;border-bottom:none">
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'column sortable',
                pagination.descending ? 'desc' : 'asc',
                header.value === pagination.sortBy ? 'active' : '',
                header.textClass
              ]"
              @click="changeSort(header.value)"
            >
              {{ header.text }}
              <v-icon small>arrow_upward</v-icon>
            </th>
          </tr>
        </template>
        <template slot="items" slot-scope="props">
          <tr style="border-color:white">
            <td
              v-for="header in headers"
              :key="header.value"
              class="text-xs-left"
              style="height:30px;"
              :style="{
                backgroundColor:
                  header.text === selectedHeader
                    ? props.item[header.value] === 'AG. NAT. DE CAD. SI PUBL.'
                      ? '#F5B4B4'
                      : props.item[header.value] === 'ELECTRICA DISTRIBUTIE TRA'
                      ? '#B2D58B'
                      : ''
                    : ''
              }"
            >
              {{ props.item[header.value] }}
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import APIService from '../APIService'
export default {
  props: {
    schema: {
      type: Object,
      required: true
    },
    queryId: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    selectedHeader: {
      type: String,
      required: false,
      default: ''
    },
    selectedValue: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      result: null,
      pagination: {
        sortBy: '_id'
      },
      selected: [],
      headers: [],
      items: []
    }
  },
  created() {
    APIService.getQuery(this.queryId)
      .then((res) => {
        this.headers = res.data.headers
      })
      .catch((ex) => {
        console.log(ex.response)
      }),
      APIService.getQueryData(this.queryId)
        .then((res) => {
          this.items = res.data
        })
        .catch((ex) => {
          console.log(ex.response)
        })
  },
  methods: {
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.sortBy = column
        this.pagination.descending = false
      }
    }
  }
}
</script>

<style scoped>
.chart {
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
  margin-bottom: 8px;
}
</style>
